module.exports = __webpack_public_path__ + "static/media/bg-hero-03-M.153013f4.png";